import React, { useEffect, useRef, useState } from "react";
import { Form, Button, Breadcrumb, Tabs, message, Modal } from "antd";
import styled from "styled-components";
import {
	useHistory,
	useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import {
	getLocations,
	getRoleList,
	getUserInfo,
	getUserList,
} from "redux/selectors";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { CALL_API, CALL_FEATCH_API } from "common/API";
import ClientAndStakeHolderForMatter from "./ClientAndStakeHolderForMatter";
import FinancialResourcePlanFieldsForMatter from "./FinancialResourcePlanFieldsForMatter";
import BillingForMatter from "./BillingForMatter";
import { currencyCodeMap } from "common/Constants";
import moment from "moment";
import { ButtonFilled } from "reusableComponent/UIButtons";

dayjs.extend(customParseFormat);

// ─── API endpoints ────────────────────────────────────────────────────────────
const API = {
	ADD_MATTER: "insyts-matter/addmatter",
	UPDATE_MATTER: "insyts-matter/updatematter",
	VIEW_MATTER: "insyts-matter/viewmatter",
};

const PRIMARY = "#2ecc71";
const PRIMARY_LIGHT = "#c2fae5";

// ─── Styled ───────────────────────────────────────────────────────────────────
const PageWrap = styled.div`
  background: #fff;
  min-height: 100vh;
  font-size: 15px;

  .ant-tabs-nav-list {
    font-weight: 600 !important;
  }
  .ant-breadcrumb-link {
    font-weight: 500 !important;
  }
  .breadcrumb-wrap {
    padding: 4px 6px 0;
    font-size: 16px;
  }

  .ant-form-item-label > label {
    font-size: 15px !important;
    font-weight: 500 !important;
  }
  .ant-input {
    font-size: 14px !important;
  }
  .ant-select-selection-item {
    font-size: 14px !important;
  }
  .ant-picker-input > input {
    font-size: 14px !important;
  }
  .ant-tabs-tab {
    font-size: 15px !important;
  }

  .stepper-wrap {
    display: flex;
    justify-content: center;
    padding: 28px 0 40px;
    margin-bottom: 50px;
  }

  .step-row {
    display: flex;
    align-items: flex-start;
  }

  .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    position: relative;
    z-index: 1;
  }

  .step-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 2px solid #d0d0d0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 600;
    color: #aaa;
    background: #fff;
    transition: all 0.3s;
    position: relative;
    z-index: 2;
  }
  .step-circle.active {
    border-color: #000;
    color: #363636;
    background: #d9fcf0;
  }
  .step-circle.done {
    color: #313131;
    background: #d9fcf0;
    border-color: ${PRIMARY};
  }

  .step-label {
    font-size: 14px;
    color: #aaa;
    font-weight: 500;
    white-space: nowrap;
  }
  .step-label.active {
    color: #a09c9c;
    font-size: 16px;
    font-weight: 500;
  }
  .step-label.done {
    color: #a09c9c;
    font-size: 16px;
    font-weight: 500;
  }

  .step-line {
    width: 120px;
    height: 2px;
    background: #d0d0d0;
    flex-shrink: 0;
    margin-left: -34px;
    margin-right: -34px;
    margin-top: 29px; 
    z-index: 0;
    position: relative;
  }
  .step-line.done {
    background: ${PRIMARY};
  }

  .ant-tabs-tab {
    font-size: 15px;
    color: #888;
    padding: 8px 0 !important;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #1a1a1a !important;
    font-weight: 600;
  }
  .ant-tabs-ink-bar {
    background: #1a1a1a !important;
  }

  .ant-picker {
    width: 100%;
  }

  .info-icon {
    color: #1677ff;
    margin-left: 5px;
    font-size: 16px;
  }

  .deadline-met-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 38px;
    margin-top: 30px;
  }
  .lookup-row {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
  }

  .section-title {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 24px 0 12px;
  }
  .section-sub {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
  }

  .resource-action-row {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-bottom: 10px;
  }
  .total-planned {
    font-weight: 700;
    font-size: 15px;
    color: #1a1a1a;
    padding: 10px 0 4px;
  }

  .permission-tag {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 13px;
    color: #333;
    background: #fff;
    width: fit-content;
  }
  .permission-edit-btn {
    color: ${PRIMARY};
    cursor: pointer;
    font-size: 16px;
  }

  .custom-rate-btn {
    background: ${PRIMARY_LIGHT} !important;
    border-color: ${PRIMARY_LIGHT} !important;
    color: #111 !important;
    border-radius: 6px !important;
    font-weight: 500 !important;
    height: 38px !important;
    width: 100%;
  }

  .form-footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: #fff;
    border-top: 1px solid #eee;
    padding: 12px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    z-index: 100;
    font-size: 16px !important;
  }

  .btn-cancel {
    border-radius: 4px !important;
    border: 1px solid #1a1a1a !important;
    color: #1a1a1a !important;
    font-weight: 500 !important;
    height: 35px !important;
    padding: 0 20px !important;
    font-size: 16px !important;
  }
  .btn-draft {
    border-radius: 4px !important;
     background: #00685F !important;
    border-color: #00685F !important;
    color: #ffffff !important;
    font-weight: 500 !important;
    height: 35px !important;
    padding: 0 20px !important;
    font-size: 16px !important;
  }
  .btn-primary {
    border-radius: 4px !important;
    background: #00685F !important;
    border-color: #00685F !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    height: 35px !important;
    padding: 0 24px !important;
    font-size: 16px !important;
  }
  .btn-update {
    border-radius: 4px !important;
    background: #00685F !important;
    border-color: #00685F !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    height: 40px !important;
    padding: 0 24px !important;
  }

  .ant-table-thead > tr > th {
    background: #e8e8e8 !important;
    font-weight: 700 !important;
    font-size: 14px !important;
    color: #333 !important;
    border-bottom: none !important;
  }
  .ant-table-tbody > tr > td {
    font-size: 13px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
  }
  .ant-table {
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    overflow: hidden;
  }

  .link-text {
    color: #1677ff;
    cursor: pointer;
    font-weight: 500;
  }
  .amount-text {
    color: #1677ff;
    font-weight: 500;
  }
`;

const getMatterStatus = (f2) => {
	if ((f2.pfa_status || "").trim() === "Not Approved") return "Not Approved";
	const billing = parseFloat(f2.billing_amount || 0);
	const cost = parseFloat(f2.usd_amount || 0);
	const profit = billing - cost;
	if (profit < 0) return "Not Approved";
	return "Not Started";
};

// ─── Payload builders ─────────────────────────────────────────────────────────
const buildAddPayload = (
	f1,
	f2,
	f3,
	resList,
	subList,
	custRates = [],
	userId,
	userInfo,
	clientList,
	selectedClientData = null,
	plannedChargeout = 0,
	plannedSubcontractor = 0,
	billingEntityList = []
) => {
	const selectedClient = clientList.find((c) => c.bdo_id === f1.client);
	const selectedEntity = billingEntityList.find((e) => e.value === f2.billing_entity);
	return {
		clientId: f1.client || "",
		client: {
			clientId: f1.client || "",
			clientName:
				selectedClient?.companyregisteredname ||
				selectedClient?.clientname ||
				"",
			clientReferenceNumber: f1.clientRef || "",
			managingOffice:
				userInfo?.managingoffice?.[0] || userInfo?.managingoffice || "",
		},
		proposalId: f1.proposalId || "",
		information: {
			jobTitle: f1.jobTitle || "",
			location: f1.location || "",
			objective: f1.objective || "",
			practiceArea: f1.practiceArea || "",
		},

		stakeHolder: {
			leadAttorney: f1.leadAttorney || "",
			referringAttorney: f1.referringAttorney || "",
			planStartDate: f1.planStartDate
				? f1.planStartDate.format("DD-MM-YYYY")
				: "",
			planEndDate: f1.planEndDate ? f1.planEndDate.format("DD-MM-YYYY") : "",
			legalFilingDeadline: f1.legalFilingDeadline
				? f1.legalFilingDeadline.format("DD-MM-YYYY")
				: "",
			deadlineMet: f1.deadlineMet || false,
		},
		matterStatus: getMatterStatus(f2),
		financial_resourcePlan: {
			billingEntity: f2.billing_entity || "",
			billingEntityId: selectedEntity?.billingEntityId || "",
			tax: f2?.tax || "",
			financialYear: f2.financial_year || "2025",
			mandays: parseFloat(f2.mandays || 0),
			currency: currencyCodeMap[f2.currency] || "USD",
			localCurrencyAmount: parseFloat(f2.billing_amount || 0),
			conversionRate: parseFloat(f2.conversion_rate || 1),
			usdAmount: parseFloat(f2.usd_amount || 0),
			billingAmount: parseFloat(f2.billing_amount || 0),
			pfaStatus: f2.pfa_status || "Not Applicable",
			plannedChargeout: parseFloat(plannedChargeout || 0),
			plannedSubcontractor: parseFloat(plannedSubcontractor || 0),
		},
		resourceList: resList.map((r) => ({
			resourceId: r?.resourceId || null,
			userId: r.userId || r.userid || r.raw?.userId || "",
			employeeName: r.employeeName || r.name || r.raw?.employeeName || "",
			employeeId: r.employeeId || r.employeeid || r.raw?.employeeId || "",
			projectRole: r.projectRole || r.role || r.raw?.projectRole || "",
			actualBookedStartDate: r.startDate
				? moment(r.startDate).format("YYYY-MM-DD")
				: r.actualBookedStartDate || r.raw?.actualBookedStartDate || null,
			actualBookedEndDate: r.finishDate
				? moment(r.finishDate).format("YYYY-MM-DD")
				: r.actualBookedEndDate || r.raw?.actualBookedEndDate || null,
			startDate: r.startDate
				? moment(r.startDate).format("YYYY-MM-DD")
				: r.raw?.startDate || null,
			endDate: r.finishDate
				? moment(r.finishDate).format("YYYY-MM-DD")
				: r.endDate || r.raw?.endDate || null,
			effort: r.effort ?? r.raw?.effort ?? 0,
			personDay: parseFloat(r.personDay ?? r.mandays ?? r.raw?.personDay ?? 0),
			resourceExtRate:
				r.resourceExtRate ??
				r.raw?.resourceExtRate ??
				parseFloat(String(r.chargeOut || "0").replace(/[^0-9.]/g, "")) ??
				0,
			status: r.status || r.raw?.status || "Assigned",
			weekList: r.weekList || r.raw?.weekList || [],
			justification: r.justification || r.raw?.justification || "",
		})),
		subcontractList: subList.map((s) => ({
			subcontractor: s.sub || "",
			description: s.description || "",
			currency: s.currency || "",
			currencycode: s.currencycode || "",
			currencyrate: s.currencyrate ?? null,
			amount: parseFloat(String(s.amount || "0").replace(/[^0-9.]/g, "")),
			referenceNo: s.refno || s.referenceNo || s.refNo || "",
			remark: s.remark || "",
		})),
		billingPreference: {
			billingMethod: f3.billingMethod || "",
			billingPreferenceEmployee:
				f3.billingMethod === "Hourly"
					? custRates
						.filter((r) => (r.employee || r.userId) && r.rate)
						.map((r) => ({
							userId: r.employee || r.userId,
							rate: parseFloat(r.rate),
						}))
					: [],
			billingHourlyRate:
				f3.billingMethod === "Hourly" && custRates.length > 0
					? parseFloat(custRates[0].rate || 0)
					: null,
			billingContingencyFee:
				f3.billingMethod === "Contingency Fee"
					? f3.billingContingencyFee || ""
					: "",
			billingFlatFee:
				f3.billingMethod === "Flat Fee"
					? f3.billingFlatFee || ""
					: "",

			// NEW
			isBillingEditable: false,
		},
		responsiblePersonnel: (f3.responsiblePersonnel || []).map((email) => {
			const found = (selectedClientData?.responsiblepersonnel || []).find(
				(p) => p.email === email
			);
			return {
				name: found ? found.name : "",
				emailid: email,
			};
		}),
		createdBy: userId,
	};
};

const buildUpdatePayload = (
	matterId,
	f1,
	f2,
	f3,
	resList,
	subList,
	custRates,
	userId,
	userInfo,
	clientList,
	selectedClientData,
	plannedChargeout = 0,
	plannedSubcontractor = 0,
	billingEntityList = []
) => ({
	matterId,
	...buildAddPayload(
		f1,
		f2,
		f3,
		resList,
		subList,
		custRates,
		userId,
		userInfo,
		clientList,
		selectedClientData,
		plannedChargeout,
		plannedSubcontractor,
		billingEntityList
	),
	updatedBy: userId,
});

const generateMatterId = () => {
	const date = new Date();
	const yyyy = date.getFullYear();
	const mm = String(date.getMonth() + 1).padStart(2, "0");
	const dd = String(date.getDate()).padStart(2, "0");
	const random = Math.floor(100 + Math.random() * 900);
	return `MA-${yyyy}${mm}${dd}-${random}`;
};

const getCurrencyKey = (value) => {
	if (!value) return "us_dollar";
	if (currencyCodeMap[value]) return value;
	const foundKey = Object.keys(currencyCodeMap).find(
		(k) => currencyCodeMap[k] === value
	);
	return foundKey || "us_dollar";
};

// ─── Edit-mode form mappers ───────────────────────────────────────────────────
const mapEditDataToForm1 = (editData) => {
	if (!editData) return {};
	const sh = editData.stakeHolder || {};
	const info = editData.information || {};

	const parseDate = (val) => {
		if (!val) return null;
		if (dayjs(val, "DD-MM-YYYY", true).isValid())
			return dayjs(val, "DD-MM-YYYY");
		if (dayjs(val).isValid()) return dayjs(val);
		return null;
	};

	return {
		matterId: editData.matterId ?? editData.matter_id ?? "",
		proposalId: editData.proposalId ?? editData.proposal_id ?? "",
		client:
			editData.client?.clientId ?? editData.clientId ?? editData.client ?? "",
		jobTitle: info.jobTitle ?? editData.jobTitle ?? editData.job_title ?? "",
		clientRef:
			editData.client?.clientReferenceNumber ??
			editData.clientReferenceNumber ??
			editData.clientRef ??
			"",
		location: info.location ?? editData.location ?? "",
		practiceArea: info.practiceArea ?? editData.practiceArea ?? undefined,
		objective: info.objective ?? editData.objective ?? "",
		leadAttorney: sh.leadAttorney ?? editData.leadAttorney ?? undefined,
		referringAttorney:
			sh.referringAttorney ?? editData.referringAttorney ?? undefined,
		planStartDate: parseDate(sh.planStartDate || editData.planStartDate),
		planEndDate: parseDate(sh.planEndDate || editData.planEndDate),
		legalFilingDeadline: parseDate(
			sh.legalFilingDeadline || editData.legalFilingDeadline
		),
		deadlineMet:
			sh.deadlineMet ??
			(editData.deadlineMet === true || editData.deadlineMet === "true") ??
			false,
	};
};

const mapEditDataToForm2 = (editData) => {
	if (!editData) return {};
	const fp = editData.financial_resourcePlan || {};

	const billingAmountRaw =
		fp.localCurrencyAmount ||
		fp.billingAmount ||
		fp.billing_amount ||
		editData.localCurrencyAmount ||
		editData.billingAmount ||
		editData.billing_amount ||
		0;

	const usdAmountRaw =
		fp.usdAmount ||
		fp.usd_amount ||
		editData.usdAmount ||
		editData.usd_amount ||
		billingAmountRaw ||
		0;

	return {
		billing_entity: fp.billingEntity ?? editData.billingEntity ?? "",
		tax: fp.tax ?? editData.tax ?? "",
		financial_year:
			fp.financialYear ??
			editData.financialYear ??
			editData.financial_year ??
			"2025",
		mandays: String(fp.mandays ?? editData.mandays ?? "0"),
		currency: getCurrencyKey(fp.currency ?? editData.currency ?? "USD"),
		billing_amount: billingAmountRaw ? String(billingAmountRaw) : "",
		conversion_rate: String(
			fp.conversionRate ??
			editData.conversionRate ??
			editData.conversion_rate ??
			"1"
		),
		usd_amount: String(usdAmountRaw),
		pfa_status:
			fp.pfaStatus ??
			editData.pfaStatus ??
			editData.pfa_status ??
			"Not Applicable",
	};
};

const mapEditDataToForm3 = (editData) => {
	if (!editData) return {};

	const bp = editData.billingPreference || {};
	const rawPersonnel = editData.responsiblePersonnel || [];

	return {
		responsiblePersonnel: rawPersonnel
			.map((p) => (typeof p === "string" ? p : p.emailid || p.email || ""))
			.filter(Boolean),

		billingMethod: editData.billingMethod || bp.billingMethod || undefined,

		billingFlatFee: editData.billingFlatFee || bp.billingFlatFee || undefined,

		billingContingencyFee:
			editData.billingContingencyFee || bp.billingContingencyFee || undefined,
	};
};

// ─── Fill-height hook ───────────────────────────────────────────────────────
// Measures how much vertical space is left in the REAL scroll container
// (.ant-layout-content — the div this app actually scrolls, not the window)
// below wherever the ref'd element sits, and returns that as a pixel value.
// Applying this as min-height on a step's wrapper means a short step
// (e.g. Billing) occupies exactly as much room as a tall step, so the
// sticky footer always lands on the same on-screen spot on every step —
// no guessed vh numbers, no scroll-position-dependent flicker.
const useFillHeight = (deps) => {
	const ref = useRef(null);
	const [height, setHeight] = useState(null);

	useEffect(() => {
		const measure = () => {
			const container = document.querySelector(".ant-layout-content");
			if (!container || !ref.current) return;
			const containerRect = container.getBoundingClientRect();
			const nodeRect = ref.current.getBoundingClientRect();
			// offsetTop is scroll-position independent: current visual offset
			// plus however far we've already scrolled cancels out to the
			// element's true offset from the top of the container's content.
			const offsetTop =
				nodeRect.top - containerRect.top + container.scrollTop;
			const available = container.clientHeight - offsetTop;
			setHeight(available > 0 ? available : 0);
		};

		// Run after paint so layout/fonts have settled.
		const raf = requestAnimationFrame(measure);

		window.addEventListener("resize", measure);
		const container = document.querySelector(".ant-layout-content");
		let ro;
		if (container && "ResizeObserver" in window) {
			ro = new ResizeObserver(measure);
			ro.observe(container);
		}

		return () => {
			cancelAnimationFrame(raf);
			window.removeEventListener("resize", measure);
			if (ro) ro.disconnect();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps);

	return [ref, height];
};

// ─── Component ────────────────────────────────────────────────────────────────
const CreateMatter = () => {
	const [form1] = Form.useForm();
	const [form2] = Form.useForm();
	const [form3] = Form.useForm();
	const location = useLocation();
	const history = useHistory();

	const [currentStep, setCurrentStep] = useState(0);
	const [submitting, setSubmitting] = useState(false);
	const [resourceList, setResourceList] = useState([]);
	// Tracks records marked as Un Assigned via the delete button in edit mode.
	// Each entry: { resourceId, userId, projectRole }
	// Used to patch the save payload so the backend receives status: "Un Assigned".
	const [unassignedRecords, setUnassignedRecords] = useState([]);
	const [subcontractorList, setSubcontractorList] = useState([]);
	const [plannedChargeout, setPlannedChargeout] = useState(0);
	const [plannedSubcontractor, setPlannedSubcontractor] = useState(0);
	const [clientList, setClientList] = useState([]);
	const [matterNameList, setMatterNameList] = useState([]);
	const [selectedClientData, setSelectedClientData] = useState(() => {
		const stored = sessionStorage.getItem("matterSelectedClientData");
		if (stored) {
			try {
				return JSON.parse(stored);
			} catch {
				return null;
			}
		}
		return null;
	});
	const [billingMethod, setBillingMethod] = useState(undefined);
	const [customRates, setCustomRates] = useState(() => {
		const stored = sessionStorage.getItem("matterCustomRates");
		if (stored) {
			try {
				return JSON.parse(stored);
			} catch {
				return [];
			}
		}
		return [];
	});
	const [activeTab, setActiveTab] = useState("1");
	const [conflictModalVisible, setConflictModalVisible] = useState(false);
	const [conflictResources, setConflictResources] = useState([]);
	const [billingEntityList, setBillingEntityList] = useState([]);

	// Create-mode: one wrapper holds all three steps (only one shown at a time).
	const [createBodyRef, createBodyHeight] = useFillHeight([currentStep]);
	// Edit-mode: each tab pane gets its own wrapper/measurement, since antd
	// keeps each pane as a separate mounted subtree.
	const [tab1BodyRef, tab1BodyHeight] = useFillHeight([activeTab === "1"]);
	const [tab2BodyRef, tab2BodyHeight] = useFillHeight([activeTab === "2"]);
	const [tab3BodyRef, tab3BodyHeight] = useFillHeight([activeTab === "3"]);

	const editData = location.state?.editData || null;
	const editMode = location.state?.editMode || null;
	const fromPath = location.state?.from || "/matter";
	const returnTab = location.state?.returnTab || "1";
	const roleList = useSelector(getRoleList);
	const roleOptions = roleList?.filter((role) => role?.display === 1);
	const locationList = useSelector(getLocations) || [];
	const userInfo = useSelector(getUserInfo);
	const userList = useSelector(getUserList);
	const userId = userInfo?.userid || userInfo?.email;

	const activeUserList = (userList || []).filter((u) => u.statusid === "1");
	const managingOffice =
		userInfo?.managingoffice?.[0] || userInfo?.managingoffice || "";
	const PARTNER_GRADES = ["P1", "P2", "P3", "P4", "P5"];
	const MANAGER_ROLE_IDS = ["5", "4"];
	const form2BillingAmountRef = useRef(null);
	const isLoadingEditData = useRef(false);

	const normalizeResource = (r) => ({
		...r,
		userId: r.userId || r.userid || r.raw?.userId || "",
		employeeId: r.employeeId || r.employeeid || r.raw?.employeeId || "",
		employeeName: r.employeeName || r.name || r.raw?.employeeName || "",
		projectRole: r.projectRole || r.role || r.raw?.projectRole || "",
		personDay: r.personDay ?? r.mandays ?? r.raw?.personDay ?? 0,
		startDate: r.startDate ? moment(r.startDate) : null,
		finishDate: r.finishDate ? moment(r.finishDate) : null,
	});

	useEffect(() => {
		fetchMatterName();
		fetchBillingEntity();
	}, []);

	useEffect(() => {
		const state = location.state;
		if (!state) return;
		if (state.openStep !== undefined) {
			setCurrentStep(state.openStep);
		}
		if (state.form1State) {
			const f1 = { ...state.form1State };
			if (f1.planStartDate)
				f1.planStartDate = dayjs(f1.planStartDate).isValid()
					? dayjs(f1.planStartDate)
					: null;
			if (f1.planEndDate)
				f1.planEndDate = dayjs(f1.planEndDate).isValid()
					? dayjs(f1.planEndDate)
					: null;
			if (f1.legalFilingDeadline)
				f1.legalFilingDeadline = dayjs(f1.legalFilingDeadline).isValid()
					? dayjs(f1.legalFilingDeadline)
					: null;
			form1.setFieldsValue(f1);
		}
		if (state.form2State) form2.setFieldsValue(state.form2State);
		if (state.form3State) form3.setFieldsValue(state.form3State);
		if (state.resourceList?.length) {
			setResourceList(state.resourceList);
		}
	}, []);

	useEffect(() => {
		if (location.state?.openStep !== undefined) {
			const stepToTabMap = {
				0: "1",
				1: "2",
				2: "3",
			};
			setActiveTab(stepToTabMap[location.state.openStep] || "1");
		}
	}, [location.state]);

	useEffect(() => {
		if (!location.state?.fromAddResource) return;
		if (location.state?.selectedClientData) {
			setSelectedClientData(location.state.selectedClientData);
		}
		const pending = sessionStorage.getItem("pendingResources");
		if (pending) {
			const parsed = JSON.parse(pending);
			setResourceList((prev) => {
				const uniqueKey = (r) => `${r.userId}_${r.projectRole}`;
				const map = new Map(prev.map((r) => [uniqueKey(r), r]));
				parsed.forEach((r) => {
					map.set(uniqueKey(r), r);
				});
				return Array.from(map.values());
			});
			sessionStorage.removeItem("pendingResources");
		}
		if (location.state?.activeTab) {
			setActiveTab(location.state.activeTab);
		}
	}, [location.state]);

	useEffect(() => {
		const init = async () => {
			if (location.state?.fromLookupCalendar) {
				await fetchClients();
				const state = location.state;
				if (state.form1State) {
					const f1 = { ...state.form1State };
					if (f1.planStartDate)
						f1.planStartDate = dayjs(f1.planStartDate).isValid()
							? dayjs(f1.planStartDate)
							: null;
					if (f1.planEndDate)
						f1.planEndDate = dayjs(f1.planEndDate).isValid()
							? dayjs(f1.planEndDate)
							: null;
					if (f1.legalFilingDeadline)
						f1.legalFilingDeadline = dayjs(f1.legalFilingDeadline).isValid()
							? dayjs(f1.legalFilingDeadline)
							: null;
					form1.setFieldsValue(f1);
				}
				if (state.form2State) form2.setFieldsValue(state.form2State);
				if (state.form3State) form3.setFieldsValue(state.form3State);
				if (state.resourceList?.length) {
					setResourceList(
						state.resourceList.map((r) => ({
							...r,
							startDate: r.startDate
								? moment(r.startDate, moment.ISO_8601, true).isValid()
									? moment(r.startDate)
									: null
								: null,
							finishDate: r.finishDate
								? moment(r.finishDate, moment.ISO_8601, true).isValid()
									? moment(r.finishDate)
									: null
								: null,
						}))
					);
				}
				if (state.subcontractorList?.length)
					setSubcontractorList(state.subcontractorList);
				if (state.openStep !== undefined) setCurrentStep(state.openStep);
				return;
			}
			const clients = await fetchClients();
			const state = location.state;
			if (state?.activeTab) setActiveTab(state.activeTab);
			if (state?.form1State) {
				const f1 = { ...state.form1State };
				if (f1.planStartDate)
					f1.planStartDate = dayjs(f1.planStartDate).isValid()
						? dayjs(f1.planStartDate)
						: null;
				if (f1.planEndDate)
					f1.planEndDate = dayjs(f1.planEndDate).isValid()
						? dayjs(f1.planEndDate)
						: null;
				if (f1.legalFilingDeadline)
					f1.legalFilingDeadline = dayjs(f1.legalFilingDeadline).isValid()
						? dayjs(f1.legalFilingDeadline)
						: null;
				form1.setFieldsValue(f1);
			}
			if (state?.form2State) form2.setFieldsValue(state.form2State);
			if (state?.form3State) form3.setFieldsValue(state.form3State);
			if (state?.resourceList?.length) {
				const rehydrated = state.resourceList?.map(normalizeResource);
				setResourceList(rehydrated);
			}
			if (state?.selectedClientData) {
				setSelectedClientData(state.selectedClientData);
			}
			if (state?.openStep !== undefined) setCurrentStep(state.openStep);
			if (
				editMode &&
				editData?.matterId &&
				!state?.fromAddResource &&
				!state?.fromLookupCalendar
			) {
				await fetchViewMatter(editData.matterId, clients);
			}
		};
		init();
		if (!editMode) {
			const id = generateMatterId();
			form1.setFieldsValue({ matterId: id });
		}
	}, [editMode, userInfo]);

	useEffect(() => {
		if (!location.state?.fromAddResource) return;
		if (location.state?.form1State) {
			const f1 = { ...location.state.form1State };
			if (location.state.planStartDate) {
				f1.planStartDate = dayjs(location.state.planStartDate);
			} else if (f1.planStartDate) {
				f1.planStartDate = dayjs(f1.planStartDate);
			}
			if (location.state.planEndDate) {
				f1.planEndDate = dayjs(location.state.planEndDate);
			} else if (f1.planEndDate) {
				f1.planEndDate = dayjs(f1.planEndDate);
			}
			if (f1.legalFilingDeadline) {
				f1.legalFilingDeadline = dayjs(f1.legalFilingDeadline);
			}
			form1.setFieldsValue(f1);
		}
		if (location.state?.form2State)
			form2.setFieldsValue(location.state.form2State);
		if (location.state?.form3State)
			form3.setFieldsValue(location.state.form3State);
		if (location.state?.resourceList?.length) {
			const rehydrated = location.state.resourceList?.map(normalizeResource);
			setResourceList(rehydrated);
		}
		if (location.state?.subcontractorList?.length) {
			setSubcontractorList(location.state.subcontractorList);
		}
		const pending = sessionStorage.getItem("pendingResources");
		if (pending) {
			try {
				const parsed = JSON.parse(pending);
				setResourceList((prev) => {
					const ids = new Set(prev.map((r) => r.userId));
					return [...prev, ...parsed.filter((r) => !ids.has(r.userId))];
				});
				sessionStorage.removeItem("pendingResources");
			} catch { }
		}
	}, [location.state]);

	useEffect(() => {
		if (!billingEntityList.length || !editMode) return;
		const currentBillingEntity = form2.getFieldValue("billing_entity");
		if (currentBillingEntity) {
			const selectedEntity = billingEntityList.find(
				(e) => e.value === currentBillingEntity
			);
			if (selectedEntity?.tax) {
				form2.setFieldsValue({ tax: selectedEntity.tax });
			}
			form2.setFieldsValue({ billing_entity: currentBillingEntity });
		}
	}, [billingEntityList]);

	useEffect(() => {
		const content = document.querySelector(".ant-layout-content");
		if (content) {
			content.scrollTo({ top: 0, behavior: "auto" });
		}
	}, [currentStep]);

	useEffect(() => {
		if (selectedClientData) {
			sessionStorage.setItem(
				"matterSelectedClientData",
				JSON.stringify(selectedClientData)
			);
		}
	}, [selectedClientData]);

	useEffect(() => {
		sessionStorage.setItem("matterCustomRates", JSON.stringify(customRates));
	}, [customRates]);

	const partnerOptions = activeUserList
		?.map((u) => ({ label: u.fullname, value: u.userid }));

	const personInchargeOptions = activeUserList
		?.map((u) => ({ label: u.fullname, value: u.userid }));

	const steps = [
		{ label: "Client & Stakeholder" },
		{ label: "Financial & Resource" },
		{ label: "Billing" },
	];

	const stepForms = [form1, form2, form3];

	const stepRequiredFields = [
		[
			"client",
			"jobTitle",
			"objective",
			"leadAttorney",
			"referringAttorney",
			"planStartDate",
			"planEndDate",
		],
		["billing_entity", "financial_year", "billing_amount", "conversion_rate"],
		[
			...(selectedClientData?.clienttype === "company"
				? ["responsiblePersonnel"]
				: []),
			"billingMethod",
			...(billingMethod === "Flat Fee" ? ["billingFlatFee"] : []),
			...(billingMethod === "Contingency Fee" ? ["billingContingencyFee"] : []),
		],
	];

	const fetchClients = async () => {
		try {
			const res = await CALL_FEATCH_API(
				"insyts-legal/getalllegalclients",
				"GET"
			);
			const data = res?.response?.data || res?.data || [];
			setClientList(data);
			return data;
		} catch (err) {
			console.error("Client fetch error:", err);
			return [];
		}
	};

	const fetchMatterName = async () => {
		try {
			const res = await CALL_FEATCH_API(
				`insyts-matter/getallmatterlist?userId=${userId}`,
				"GET"
			);
			const data = res?.response?.data || res?.data || [];
			setMatterNameList(data);
			return data;
		} catch (err) {
			console.error("Client fetch error:", err);
			return [];
		}
	};

	const fetchViewMatter = async (matterId, clients = []) => {
		try {
			const resp = await CALL_FEATCH_API(
				`${API.VIEW_MATTER}?matterid=${matterId}`,
				"GET"
			);
			if (!resp) return;
			const raw = resp.response?.data || resp.response || resp.data || resp;
			const responsiblePersonnel = (
				raw?.responsiblePersonnel?.length
					? raw.responsiblePersonnel
					: editData?.responsiblePersonnel || []
			)
				.map((p) => (typeof p === "string" ? p : p.emailid || p.email || ""))
				.filter(Boolean);
			const merged = { ...raw, responsiblePersonnel };
			isLoadingEditData.current = true;
			form1.setFieldsValue(mapEditDataToForm1(merged));
			setTimeout(() => { isLoadingEditData.current = false; }, 0);
			const f2mapped = mapEditDataToForm2(merged);
			form2.setFieldsValue(f2mapped);
			if (f2mapped.billing_amount && parseFloat(f2mapped.billing_amount) > 0) {
				form2BillingAmountRef.current = f2mapped.billing_amount;
			}
			const billingAmt = parseFloat(f2mapped.billing_amount || 0);
			const convRate = parseFloat(f2mapped.conversion_rate || 1);
			if (billingAmt && convRate) {
				form2.setFieldsValue({
					usd_amount: (billingAmt * convRate).toFixed(2),
				});
			}

			const bp = raw.billingPreference || {};
			const bMethod =
				raw.billingMethod ||
				bp.billingMethod ||
				editData?.billingMethod ||
				editData?.billingPreference?.billingMethod ||
				undefined;

			const form3Values = {
				responsiblePersonnel,
				billingMethod: bMethod || undefined,
				billingFlatFee:
					bp.billingFlatFee ||
					raw.billingFlatFee ||
					editData?.billingPreference?.billingFlatFee ||
					undefined,
				billingContingencyFee:
					bp.billingContingencyFee ||
					raw.billingContingencyFee ||
					editData?.billingPreference?.billingContingencyFee ||
					undefined,
			};

			form3.setFieldsValue(form3Values);

			if (bMethod) setBillingMethod(bMethod);

			const billingEmployees =
				raw.billingPreferenceEmployee || bp.billingPreferenceEmployee || [];
			if (billingEmployees?.length > 0) {
				const rateMap = new Map();
				billingEmployees.forEach((r) => {
					const uid = r.userId || r.userid || "";
					if (uid)
						rateMap.set(uid, { userId: uid, rate: String(r.rate || "") });
				});
				setCustomRates(Array.from(rateMap.values()));
			}

			// resource list
			const resList = raw.resourceList || raw.employeeList || [];
			if (resList.length) {
				setResourceList(
					resList.map((r, i) => ({
						key: r.userid || r.userId || String(i),
						resourceId: r.resourceId || null,
						name: r.employeename || r.employeeName || "",
						employeeId: r.employeeid || r.employeeId || "",
						userId: r.userid || r.userId || "",
						role: r.projectrole || r.projectRole || "",
						projectRole: r.projectrole || r.projectRole || "",
						mandays: r.personday ?? r.personDay ?? 0,
						chargeOut: `$${r.resourceExtRate || 0}/hr`,
						bookedHours: "",
						totalPco: "",
						resourceExtRate: r.resourceExtRate || 0,
						startDate: r.actualBookedStartDate
							? moment(r.actualBookedStartDate)
							: null,
						finishDate: r.actualBookedEndDate
							? moment(r.actualBookedEndDate)
							: null,
						status: r.status || "Assigned",
						justification: r.justification || "",
						raw: r,
					}))
				);
			}

			if (raw.subcontractList?.length) {
				setSubcontractorList(
					raw.subcontractList.map((s, i) => ({
						key: String(i),
						sub: s.subcontractor || "",
						description: s.description || "",
						currency: s.currency || "",
						currencycode: s.currencycode || "",
						currencyrate: s.currencyrate ?? null,
						amount: String(s.amount || ""),
						refNo: s.referenceNo || s.refno || s.refNo || "",
						remark: s.remark || "",
					}))
				);
			}

			const cid = raw.clientId || raw.client?.clientId;
			const allClients = clients?.length ? clients : clientList;
			const found = allClients.find((c) => c.bdo_id === cid);
			if (found && !location.state?.fromAddResource) {
				setSelectedClientData(found);
			}
		} catch (err) {
			console.error("fetchViewMatter error:", err);
		}
	};

	const fetchBillingEntity = async () => {
		try {
			const res = await CALL_FEATCH_API("insyts-billing-entity/getbillingentity", "GET");
			const data = res?.response?.data || res?.data || [];
			const list = (Array.isArray(data) ? data : [data])
				.map((entity) => {
					const name = entity?.billingEntityName || entity?.name || entity?.billingentityname || "";
					const id = entity?.billingEntityId || entity?.id || entity?.billingentityid || "";
					const tax = entity?.tax || entity?.taxRate || entity?.taxrate || "";
					return { label: name, value: name, billingEntityId: id, tax }; // ← store id here
				})
				.filter((e) => e.label);
			setBillingEntityList(list);
		} catch (err) {
			console.error("Billing Entity fetch error:", err);
		}
	};

	const buildResourceFromUser = (user, role, keySuffix) => ({
		key: `${user.userid || user.email}_${keySuffix}`,
		userId: user.userid || user.email || "",
		employeeId: user.employeeid || user.employeeId || user.empid || "",
		name: user.fullname || "",
		employeeName: user.fullname || "",
		role,
		projectRole: role,
		mandays: 0,
		chargeOut: `$${user.chargeoutrate || 0}/hr`,
		resourceExtRate: user.chargeoutrate || 0,
		bookedHours: "",
		totalPco: "",
		startDate: null,
		finishDate: null,
		status: "Assigned",
	});

	/**
	 * Shared helper: replaces the resource holding `role` with `user`.
	 * In edit mode: the previous holder is demoted to "Member".
	 * In add mode: the previous holder is simply replaced (original behaviour).
	 */
	const demoteAndReplaceRole = (role, user) => {
		const keySuffix = role === "Lead Attorney" ? "lead" : "referring";
		setResourceList((prev) => {
			const existing = prev.find((r) => r.projectRole === role);
			const newUserId = user.userid || user.email || "";

			if (existing) {
				const existingUserId = existing.userId || existing.userid || "";
				// Same person re-selected - nothing to do
				if (existingUserId === newUserId) return prev;

				if (editMode) {
					// EDIT mode: demote the outgoing attorney to "Member".
					// Use the original role as part of the key so that if the same
					// user held BOTH Lead Attorney and Referring Attorney, each
					// demotion produces its own distinct Member row.
					const demotedKey = `${existingUserId}_member_${role.replace(/\s+/g, "_").toLowerCase()}`;
					const demoted = {
						...existing,
						role: "Member",
						projectRole: "Member",
						key: demotedKey,
						// Carry the original role so the merge in
						// FinancialResourcePlanFieldsForMatter can match it back
						// to the correct API row without collisions.
						originalRole: role,
						raw: existing.raw
							? { ...existing.raw, projectRole: "Member", originalRole: role }
							: existing.raw,
					};

					// Drop only the old role row for this specific role.
					// Do NOT remove other Member rows that came from different roles.
					const withoutOld = prev.filter(
						(r) =>
							r.projectRole !== role &&
							!(
								r.projectRole === "Member" &&
								(r.userId || r.userid || "") === existingUserId &&
								r.originalRole === role
							)
					);

					const newRow = buildResourceFromUser(user, role, keySuffix);
					return [...withoutOld, demoted, newRow];
				} else {
					// ADD mode: simply replace the old row (no demotion)
					const withoutOld = prev.filter((r) => r.projectRole !== role);
					const newRow = buildResourceFromUser(user, role, keySuffix);
					return [...withoutOld, newRow];
				}
			}

			// No previous holder - just add the new row
			const newRow = buildResourceFromUser(user, role, keySuffix);
			return [...prev, newRow];
		});
	};

	const handleLeadAttorneyChange = (userId) => {
		if (isLoadingEditData.current) return;
		if (!userId) return;
		const user =
			userList.find((u) => u.userid === userId) ||
			activeUserList.find((u) => u.userid === userId);
		if (!user) return;
		demoteAndReplaceRole("Lead Attorney", user);
	};

	const handleReferringAttorneyChange = (userId) => {
		if (isLoadingEditData.current) return;
		if (!userId) return;
		const user =
			userList.find((u) => u.userid === userId) ||
			activeUserList.find((u) => u.userid === userId);
		if (!user) return;
		demoteAndReplaceRole("Referring Attorney", user);
	};

	const handleNavigateToAddResources = ({
		leadAttorneyId,
		referringAttorneyId,
		planStartDate,
		planEndDate,
	}) => {
		try {
			const f1 = form1.getFieldsValue();
			const f2 = form2.getFieldsValue();
			const f3 = form3.getFieldsValue();

			const serializeDate = (value) => {
				if (!value) return null;
				if (typeof value === "string") return value;
				if (typeof value?.format === "function") {
					return value.format("YYYY-MM-DD");
				}
				if (value instanceof Date) {
					return value.toISOString().split("T")[0];
				}
				return null;
			};

			const toPlain = (val) => {
				if (val === null || val === undefined) return val;
				if (typeof val?.format === "function") return serializeDate(val);
				if (val instanceof Date) return val.toISOString().split("T")[0];
				if (Array.isArray(val)) return val.map(toPlain);
				if (typeof val === "object") {
					const result = {};
					Object.keys(val).forEach((k) => {
						result[k] = toPlain(val[k]);
					});
					return result;
				}
				return val;
			};
			history.push("/create-matter/add-resources", {
				openStep: currentStep,
				form1State: toPlain(f1),
				form2State: toPlain(f2),
				form3State: toPlain(f3),
				resourceList: toPlain(resourceList),
				subcontractorList: toPlain(subcontractorList || []),
				editMode,
				editData: toPlain(editData),
				formTitle: editMode
					? editData?.information?.jobTitle ||
					editData?.jobTitle ||
					"Editing Matter"
					: "Creating Matter",
				leadAttorneyId: leadAttorneyId || f1.leadAttorney,
				referringAttorneyId: referringAttorneyId || f1.referringAttorney,
				planStartDate: serializeDate(planStartDate || f1.planStartDate),
				planEndDate: serializeDate(planEndDate || f1.planEndDate),
				activeTab,
				fromAddButton: true,
				selectedClientData: location.state?.selectedClientData,
			});
		} catch (err) {
			console.error("Navigation error:", err);
		}
	};

	const handleLookupCalendar = () => {
		const f1 = form1.getFieldsValue();
		const f2 = form2.getFieldsValue();
		const f3 = form3.getFieldsValue();

		const serializeDate = (value) => {
			if (!value) return null;
			if (typeof value === "string") return value;
			if (typeof value?.format === "function")
				return value.format("YYYY-MM-DD");
			if (value instanceof Date) return value.toISOString().split("T")[0];
			return null;
		};

		const toPlain = (val) => {
			if (val === null || val === undefined) return val;
			if (typeof val?.format === "function") return serializeDate(val);
			if (val instanceof Date) return val.toISOString().split("T")[0];
			if (Array.isArray(val)) return val.map(toPlain);
			if (typeof val === "object") {
				const result = {};
				Object.keys(val).forEach((k) => {
					result[k] = toPlain(val[k]);
				});
				return result;
			}
			return val;
		};

		history.push("/matterLookUpCalendar", {
			fromCreateMatter: true,
			openStep: currentStep,
			form1State: toPlain(f1),
			form2State: toPlain(f2),
			form3State: toPlain(f3),
			resourceList: toPlain(resourceList),
			subcontractorList: toPlain(subcontractorList || []),
			editMode,
			editData: toPlain(editData),
		});
	};

	const getSafeF2 = () => {
		const f2raw = form2.getFieldsValue();
		if (
			(!f2raw.billing_amount || parseFloat(f2raw.billing_amount) === 0) &&
			form2BillingAmountRef.current &&
			parseFloat(form2BillingAmountRef.current) > 0
		) {
			return {
				...f2raw,
				billing_amount: form2BillingAmountRef.current,
				usd_amount: String(
					(
						parseFloat(form2BillingAmountRef.current) *
						parseFloat(f2raw.conversion_rate || 1)
					).toFixed(2)
				),
			};
		}
		return f2raw;
	};

	const f2 = getSafeF2();

	const validateCustomRates = () => {
		if (billingMethod !== "Hourly") return true;
		if (customRates?.length === 0) return true; // no rows added = nothing to validate

		const invalid = customRates.some(
			(r) => !r.userId || !r.rate || isNaN(r.rate) || Number(r.rate) <= 0
		);

		if (invalid) {
			message.error(
				"Please fill in all custom hourly rate rows with a valid employee and rate."
			);
			return false;
		}
		return true;
	};

	const getEditableFlags = (f1, f2, f3, resList) => {
		if (!editData) return {};

		// ── Read from same paths as mapEditDataToForm functions ──────
		const sh = editData.stakeHolder || {};
		const info = editData.information || {};
		const fp = editData.financial_resourcePlan || {};
		const bp = editData.billingPreference || {};

		const norm = (val) => String(val ?? "").trim();
		const normNum = (val) => parseFloat(val || 0);
		const normText = (val) => norm(val).replace(/\s+/g, " ");
		const normDate = (val) => {
			if (!val) return "";
			if (typeof val?.format === "function") return val.format("DD-MM-YYYY");
			return norm(val);
		};

		// Guard: if forms not yet populated, skip all comparisons
		const f1Empty = !f1.jobTitle && !f1.client && !f1.leadAttorney;
		const f2Empty = !f2.billing_entity && !f2.financial_year && !f2.billing_amount;
		if (f1Empty && f2Empty) {
			console.warn("getEditableFlags: forms not populated yet, skipping");
			return {};
		}

		// ── Client ────────────────────────────────────────────────────
		const origClientId = norm(editData.client?.clientId || editData.clientId || "");
		const isClientEditable = norm(f1.client) !== origClientId;

		// ── Info ──────────────────────────────────────────────────────
		// Read from nested info OR flat editData
		const origJobTitle = normText(info.jobTitle ?? editData.jobTitle ?? "");
		const origLocation = normText(info.location ?? editData.location ?? "");
		const origObjective = normText(info.objective ?? editData.objective ?? "");
		const origPractice = norm(info.practiceArea ?? editData.practiceArea ?? "");

		const jobTitleChanged = normText(f1.jobTitle) !== origJobTitle;
		const locationChanged = normText(f1.location) !== origLocation;
		const objectiveChanged = normText(f1.objective) !== origObjective;
		const practiceChanged = norm(f1.practiceArea) !== origPractice;

		const isInfoEditable =
			jobTitleChanged || locationChanged || objectiveChanged || practiceChanged;

		// ── StakeHolder ───────────────────────────────────────────────
		// Read from nested sh OR flat editData
		const origLead = norm(sh.leadAttorney ?? editData.leadAttorney ?? "");
		const origReferring = norm(sh.referringAttorney ?? editData.referringAttorney ?? "");
		const origStart = norm(sh.planStartDate ?? editData.planStartDate ?? "");
		const origEnd = norm(sh.planEndDate ?? editData.planEndDate ?? "");
		const origDeadline = norm(sh.legalFilingDeadline ?? editData.legalFilingDeadline ?? "");
		const origDeadlineMet = !!(sh.deadlineMet ?? editData.deadlineMet ?? false);

		const isStakeHolderEditable =
			norm(f1.leadAttorney) !== origLead ||
			norm(f1.referringAttorney) !== origReferring ||
			normDate(f1.planStartDate) !== origStart ||
			normDate(f1.planEndDate) !== origEnd ||
			normDate(f1.legalFilingDeadline) !== origDeadline ||
			!!f1.deadlineMet !== origDeadlineMet;

		// ── Financial ─────────────────────────────────────────────────
		// Read from nested fp OR flat editData
		const origBillingEntity = norm(fp.billingEntity ?? editData.billingEntity ?? "");
		const origFinancialYear = norm(String(fp.financialYear ?? editData.financialYear ?? editData.financial_year ?? ""));
		const origCurrencyCode = norm(fp.currency ?? editData.currency ?? "USD");
		const origBillingAmount = normNum(fp.localCurrencyAmount ?? fp.billingAmount ?? editData.billingAmount ?? 0);
		const origConversionRate = normNum(fp.conversionRate ?? editData.conversionRate ?? 1);
		// NOTE: mandays and tax are also part of the Financial & Resource Plan
		// tab, so they must feed into the "did anything on this tab change"
		// check too — otherwise editing only mandays/tax would silently NOT
		// set isFinancialEditable even though the user changed that tab.
		const origMandays = normNum(fp.mandays ?? editData.mandays ?? 0);
		const origTax = norm(fp.tax ?? editData.tax ?? "");

		// Convert form currency key "us_dollar" → "USD" via currencyCodeMap
		const currentCurrencyCode = currencyCodeMap[norm(f2.currency)] || norm(f2.currency);

		const isFinancialEditable =
			norm(f2.billing_entity) !== origBillingEntity ||
			norm(f2.financial_year) !== origFinancialYear ||
			currentCurrencyCode !== origCurrencyCode ||
			normNum(f2.billing_amount) !== origBillingAmount ||
			normNum(f2.conversion_rate) !== origConversionRate ||
			normNum(f2.mandays) !== origMandays ||
			norm(f2.tax) !== origTax;

		const currentBillingEmployees = (customRates || [])
			.filter((r) => r.userId && r.rate)
			.map((r) => ({
				userId: r.userId,
				rate: Number(r.rate),
			}))
			.sort((a, b) => a.userId.localeCompare(b.userId));

		const originalBillingEmployees = (bp.billingPreferenceEmployee || [])
			.map((r) => ({
				userId: r.userId,
				rate: Number(r.rate),
			}))
			.sort((a, b) => a.userId.localeCompare(b.userId));

		const isBillingEditable =
			norm(f3.billingMethod) !== norm(bp.billingMethod) ||
			norm(f3.billingFlatFee) !== norm(bp.billingFlatFee) ||
			norm(f3.billingContingencyFee) !== norm(bp.billingContingencyFee) ||
			JSON.stringify(currentBillingEmployees) !==
			JSON.stringify(originalBillingEmployees);

		// ── Resource — member adds/edits only ─────────────────────────
		const originalResourceList = editData.resourceList || editData.employeeList || [];

		const isMember = (role) =>
			role &&
			role !== "Lead Attorney" &&
			role !== "Referring Attorney" &&
			role !== "Reffering Attorney";

		const origMembers = new Map(
			originalResourceList
				.filter(r => isMember(r.projectRole))
				.map(r => [`${norm(r.userId || r.userid)}_${norm(r.projectRole)}`, r])
		);

		const currMembers = new Map(
			resList
				.filter(r => isMember(r.projectRole || r.role || r.raw?.projectRole))
				.map(r => [
					`${norm(r.userId || r.userid || r.raw?.userId)}_${norm(r.projectRole || r.role || r.raw?.projectRole)}`,
					r,
				])
		);

		const memberAdded = [...currMembers.keys()].some(k => !origMembers.has(k));
		const memberRemoved = [...origMembers.keys()].some(k => !currMembers.has(k));
		const memberModified = [...currMembers.entries()].some(([k, r]) => {
			const orig = origMembers.get(k);
			if (!orig) return false;
			return (
				normNum(r.mandays ?? r.personDay ?? r.raw?.personDay) !== normNum(orig.personDay) ||
				norm(r.status || r.raw?.status) !== norm(orig.status) ||
				norm(r.justification || r.raw?.justification) !== norm(orig.justification)
			);
		});

		const isResourceEditable = memberAdded || memberRemoved || memberModified;

		return {
			isClientEditable,
			isInfoEditable,
			isStakeHolderEditable,
			isFinancialEditable,
			isResourceEditable,
			isBillingEditable
		};
	};

	// ── Create ───────────────────────────────────────────────────────────────
	const handleCreate = async () => {
		setSubmitting(true);
		try {
			const [f1, f3] = await Promise.all([
				form1.validateFields(),
				form3.validateFields(),
			]);
			const f2 = getSafeF2();

			if (!validateCustomRates()) {
				setSubmitting(false);
				return;
			}

			if (isDraft && editData?.matterId) {
				const matterId = editData.matterId || editData.matter_id || "";
				const payload = buildUpdatePayload(
					matterId,
					f1,
					f2,
					f3,
					resourceList,
					subcontractorList,
					customRates,
					userId,
					userInfo,
					clientList,
					selectedClientData,
					plannedChargeout,
					plannedSubcontractor,
					billingEntityList
				);
				payload.matterStatus = getMatterStatus(f2);

				// ── Apply edit flags so backend knows exactly which section changed ──
				const flags = getEditableFlags(f1, f2, f3, resourceList);
				if (flags.isClientEditable) payload.client.isClientEditable = true;
				if (flags.isInfoEditable) payload.information.isInfoEditable = true;
				if (flags.isStakeHolderEditable) payload.stakeHolder.isStakeHolderEditable = true;
				if (flags.isFinancialEditable) payload.financial_resourcePlan.isFinancialEditable = true;
				if (flags.isResourceEditable) payload.isResourceEditable = true;
				if (flags.isBillingEditable) {
					payload.billingPreference.isBillingEditable = true;
				}

				await CALL_API(API.UPDATE_MATTER, "PATCH", payload);
				message.success("Matter submitted successfully!");
			} else {
				const payload = buildAddPayload(
					f1,
					f2,
					f3,
					resourceList,
					subcontractorList,
					customRates,
					userId,
					userInfo,
					clientList,
					selectedClientData,
					plannedChargeout,
					plannedSubcontractor,
					billingEntityList
				);
				await CALL_API(API.ADD_MATTER, "POST", payload);
				message.success("Matter created successfully!");
			}
			history.push("/matter");
		} catch (err) {
			console.error("handleCreate error:", err);
			message.error("Failed to submit matter. Please try again.");
		} finally {
			setSubmitting(false);
		}
	};

	const handleSaveAsDraft = async () => {
		setSubmitting(true);
		try {
			const [f1, f3] = [form1.getFieldsValue(), form3.getFieldsValue()];
			const f2 = getSafeF2();

			const existingMatterId =
				editData?.matterId ||
				editData?.matter_id ||
				form1.getFieldValue("matterId");

			if (isDraft && existingMatterId) {
				const payload = {
					...buildUpdatePayload(
						existingMatterId,
						f1,
						f2,
						f3,
						resourceList,
						subcontractorList,
						customRates,
						userId,
						userInfo,
						clientList,
						selectedClientData,
						plannedChargeout,
						plannedSubcontractor,
						billingEntityList
					),
					matterStatus: "Draft",
				};
				if (unassignedRecords.length > 0) {
					payload.resourceList = payload.resourceList.map(record => {
						const isUnassigned = unassignedRecords.some(
							item =>
								String(item.resourceId) === String(record.resourceId) &&
								item.userId === record.userId
						);
						return {
							...record,
							status: isUnassigned ? "Un Assigned" : record.status,
						};
					});
				}
				await CALL_API(API.UPDATE_MATTER, "PATCH", payload);
				message.success("Draft updated successfully.");
			} else {
				const payload = {
					...buildAddPayload(
						f1,
						f2,
						f3,
						resourceList,
						subcontractorList,
						customRates,
						userId,
						userInfo,
						clientList,
						selectedClientData,
						plannedChargeout,
						plannedSubcontractor
					),
					matterStatus: "Draft",
				};
				await CALL_API(API.ADD_MATTER, "POST", payload);
				message.success("Matter saved as draft.");
			}

			history.push("/matter");
		} catch (err) {
			console.error("handleSaveAsDraft error:", err);
			message.error("Failed to save draft.");
		} finally {
			setSubmitting(false);
		}
	};

	const handleTabUpdate = async (form, fields) => {
		try {
			await form.validateFields(fields);
		} catch {
			message.error("Please fill in all required fields.");
			return;
		}
		if (activeTab === "3" && !validateCustomRates()) return;

		// Validate resource dates against updated plan dates for Draft / Not Started / Not Approved
		// NOTE: This check runs regardless of which tab the Update button is clicked from,
		// because plan dates (form1) can conflict with resources even when saving from tab 2 or 3.
		{
			const currentMatterStatus =
				editData?.matterStatus ||
				editData?.originalData?.matterStatus ||
				"";
			const editableStatuses = ["Draft", "Not Started", "Not Approved"];
			if (editableStatuses.includes(currentMatterStatus)) {
				const f1Values = form1.getFieldsValue();
				const newPlanStart = f1Values.planStartDate
					? dayjs(f1Values.planStartDate).startOf("day")
					: null;
				const newPlanEnd = f1Values.planEndDate
					? dayjs(f1Values.planEndDate).startOf("day")
					: null;

				if (newPlanStart && newPlanEnd && resourceList.length > 0) {
					const conflicting = resourceList.filter((resource) => {
						const resStart = resource.startDate
							? dayjs(resource.startDate).startOf("day")
							: null;
						// Use finishDate first, fall back to endDate
						const resEndRaw = resource.finishDate || resource.endDate || null;
						const resEnd = resEndRaw
							? dayjs(resEndRaw).startOf("day")
							: null;
						if (!resStart && !resEnd) return false;
						const startOk = resStart
							? resStart.isSame(newPlanStart) || resStart.isAfter(newPlanStart)
							: true;
						const endOk = resEnd
							? resEnd.isSame(newPlanEnd) || resEnd.isBefore(newPlanEnd)
							: true;
						return !startOk || !endOk;
					});
					const hasConflict = conflicting.length > 0;

					if (hasConflict) {
						setConflictResources(conflicting);
						setConflictModalVisible(true);
						return;
					}
				}
			}
		}

		setSubmitting(true);
		try {
			const f1 = form1.getFieldsValue();
			const f2raw = form2.getFieldsValue();
			const f3raw = form3.getFieldsValue();

			const f2 = { ...f2raw };
			if (
				(!f2.billing_amount || parseFloat(f2.billing_amount) === 0) &&
				form2BillingAmountRef.current &&
				parseFloat(form2BillingAmountRef.current) > 0
			) {
				f2.billing_amount = form2BillingAmountRef.current;
				f2.usd_amount = String(
					(
						parseFloat(f2.billing_amount) * parseFloat(f2.conversion_rate || 1)
					).toFixed(2)
				);
			}

			const existingFp = editData?.financial_resourcePlan || {};
			if (!f2.currency) {
				f2.currency = getCurrencyKey(
					existingFp.currency ?? editData?.currency ?? "us_dollar"
				);
			}
			if (!f2.billing_entity) {
				f2.billing_entity =
					existingFp.billingEntity ?? editData?.billingEntity ?? "";
			}
			if (!f2.financial_year) {
				f2.financial_year =
					existingFp.financialYear ??
					editData?.financialYear ??
					editData?.financial_year ??
					"2025";
			}
			if (!f2.tax) {
				f2.tax = existingFp.tax ?? editData?.tax ?? "";
			}
			if (!f2.mandays) {
				f2.mandays = String(existingFp.mandays ?? editData?.mandays ?? "0");
			}
			if (!f2.conversion_rate) {
				f2.conversion_rate = String(
					existingFp.conversionRate ??
					editData?.conversionRate ??
					editData?.conversion_rate ??
					"1"
				);
			}
			if (!f2.pfa_status) {
				f2.pfa_status =
					existingFp.pfaStatus ??
					editData?.pfaStatus ??
					editData?.pfa_status ??
					"Not Applicable";
			}

			// ✅ FIX: If form3 fields are empty (tab not visited), fall back to editData values
			const existingBp = editData?.billingPreference || {};
			const f3 = {
				billingMethod:
					f3raw.billingMethod ||
					editData?.billingMethod ||
					existingBp.billingMethod ||
					"",
				billingFlatFee:
					f3raw.billingFlatFee ||
					existingBp.billingFlatFee ||
					editData?.billingFlatFee ||
					"",
				billingContingencyFee:
					f3raw.billingContingencyFee ||
					existingBp.billingContingencyFee ||
					editData?.billingContingencyFee ||
					"",
				responsiblePersonnel: f3raw.responsiblePersonnel?.length
					? f3raw.responsiblePersonnel
					: (editData?.responsiblePersonnel || [])
						.map((p) =>
							typeof p === "string" ? p : p.emailid || p.email || ""
						)
						.filter(Boolean),
			};

			const existingCustRates = (
				existingBp.billingPreferenceEmployee || []
			).map((r) => ({
				userId: r.userId || r.userid,
				rate: r.rate,
			}));
			const resolvedCustomRates =
				customRates.length > 0 ? customRates : existingCustRates;

			const matterId = editData?.matterId || editData?.matter_id || "";
			const payload = buildUpdatePayload(
				matterId,
				f1,
				f2,
				f3,
				resourceList,
				subcontractorList,
				resolvedCustomRates,
				userId,
				userInfo,
				clientList,
				selectedClientData,
				plannedChargeout,
				plannedSubcontractor,
				billingEntityList
			);

			const flags = getEditableFlags(f1, f2, f3, resourceList);

			if (flags.isClientEditable) payload.client.isClientEditable = true;
			if (flags.isInfoEditable) payload.information.isInfoEditable = true;
			if (flags.isStakeHolderEditable) payload.stakeHolder.isStakeHolderEditable = true;
			if (flags.isFinancialEditable) payload.financial_resourcePlan.isFinancialEditable = true;

			if (flags.isResourceEditable) payload.isResourceEditable = true;
			if (flags.isBillingEditable) {
				payload.billingPreference.isBillingEditable = true;
			}

			if (unassignedRecords.length > 0) {
				payload.resourceList = payload.resourceList.map(record => {
					const isUnassigned = unassignedRecords.some(
						item =>
							String(item.resourceId) === String(record.resourceId) &&
							item.userId === record.userId
					);

					return {
						...record,
						status: isUnassigned ? "Un Assigned" : record.status
					};
				});
			}
			await CALL_API(API.UPDATE_MATTER, "PATCH", payload);
			message.success("Updated successfully!");
			setTimeout(() => history.push(fromPath), 300);
		} catch (err) {
			console.error("handleTabUpdate error:", err);
			message.error("Failed to update matter.");
		} finally {
			setSubmitting(false);
		}
	};

	const handleNext = async () => {

		try {
			await stepForms[currentStep].validateFields(
				stepRequiredFields[currentStep]
			);
			if (currentStep === 2 && !validateCustomRates()) {
				return;
			}
			if (currentStep < 2) setCurrentStep((prev) => prev + 1);
			else await handleCreate();
		} catch {
			message.error("Please fill in all required fields before proceeding.");
		}
	};

	const handlePrev = () => {
		if (currentStep > 0) setCurrentStep((prev) => prev - 1);
	};

	const sharedStep1Props = {
		form: form1,
		clientList,
		onClientChange: setSelectedClientData,
		partnerOptions,
		personInchargeOptions,
		onLeadAttorneyChange: handleLeadAttorneyChange,
		onReferringAttorneyChange: handleReferringAttorneyChange,
		matterNameList,
		onLookup: handleLookupCalendar,
		isEditMode: !!editMode,
		currentMatterName:
			editData?.information?.jobTitle || editData?.jobTitle || "",
		resourceList,
		matterStatus: editData?.matterStatus || "Not Started",
	};

	const sharedStep2Props = {
		form: form2,
		resourceList,
		setResourceList,
		subcontractorList,
		setSubcontractorList,
		onNavigateToAddResources: handleNavigateToAddResources,
		matterData: editData,
		isEditMode: !!editMode,
		parentForm: form1,
		billingEntityList,
		onChargeoutChange: setPlannedChargeout,
		onSubcontractorChange: setPlannedSubcontractor,
		onUnassignedKeysChange: setUnassignedRecords,
	};

	const sharedStep3Props = {
		form: form3,
		roleList: roleOptions,
		locationList,
		selectedClientData,
		billingMethod,
		onBillingMethodChange: setBillingMethod,
		customRates,
		setCustomRates,
		userList,
		resourceList,
	};
	const isDraft =
		editData?.matterStatus === "Draft" ||
		editData?.originalData?.matterStatus === "Draft";

	// ── CREATE MODE ───────────────────────────────────────────────────────────

	if (!editMode || isDraft) {
		return (
			<PageWrap>
				<div className="breadcrumb-wrap">
					<Breadcrumb>
						<Breadcrumb.Item
							onClick={() => history.push("/matter")}
							style={{ cursor: "pointer", color: "#8c98aa" }}
						>
							Matter
						</Breadcrumb.Item>
						<Breadcrumb.Item>Creating Matter</Breadcrumb.Item>
					</Breadcrumb>
				</div>

				<div className="stepper-wrap">
					<div className="step-row">
						{steps.map((step, index) => (
							<React.Fragment key={index}>
								<div className="step-item">
									<div
										className={`step-circle ${index < currentStep
											? "done"
											: index === currentStep
												? "active"
												: ""
											}`}
									>
										{index + 1}
									</div>
									<div
										className={`step-label ${index < currentStep
											? "done"
											: index === currentStep
												? "active"
												: ""
											}`}
									>
										{step.label}
									</div>
								</div>
								{index < steps.length - 1 && (
									<div
										className={`step-line ${index < currentStep ? "done" : ""}`}
									/>
								)}
							</React.Fragment>
						))}
					</div>
				</div>

				<div
					ref={createBodyRef}
					style={{
						minHeight: createBodyHeight ? `${createBodyHeight}px` : undefined,
					}}
				>
					<div style={{ display: currentStep === 0 ? "block" : "none" }}>
						<ClientAndStakeHolderForMatter {...sharedStep1Props} />
					</div>
					<div style={{ display: currentStep === 1 ? "block" : "none" }}>
						<FinancialResourcePlanFieldsForMatter
							{...sharedStep2Props}
							isEditMode={editMode}
						/>
					</div>
					<div style={{ display: currentStep === 2 ? "block" : "none" }}>
						<BillingForMatter {...sharedStep3Props} />
					</div>
				</div>

				<div className="form-footer">
					<Button
						className="btn-cancel"
						onClick={() => history.push("/matter")}
					>
						Cancel
					</Button>
					{currentStep > 0 && (
						<Button className="btn-cancel" onClick={handlePrev}>
							Previous
						</Button>
					)}
					<Button
						className="btn-draft"
						loading={submitting}
						onClick={handleSaveAsDraft}
					>
						Save as Draft
					</Button>
					<Button
						className="btn-primary"
						loading={submitting}
						onClick={handleNext}
					>
						{currentStep === 2 ? "Create" : "Next"}
					</Button>
				</div>
			</PageWrap>
		);
	}

	// ── EDIT MODE ─────────────────────────────────────────────────────────────

	const handleTabChange = async (newKey) => {
		const keyToStep = { 1: 0, 2: 1, 3: 2 };
		const currentStepIndex = keyToStep[activeTab];
		if (currentStepIndex === undefined) {
			setActiveTab(newKey);
			return;
		}
		try {
			await stepForms[currentStepIndex].validateFields(
				stepRequiredFields[currentStepIndex]
			);
			setActiveTab(newKey);
		} catch {
			message.error(
				"Please fill in all required fields before switching tabs."
			);
		}
	};

	const tabItems = [
		{
			key: "1",
			label: "Client & Stakeholder",
			children: (
				<>
					<div
						ref={tab1BodyRef}
						style={{
							minHeight: tab1BodyHeight ? `${tab1BodyHeight}px` : undefined,
						}}
					>
						<ClientAndStakeHolderForMatter {...sharedStep1Props} />
					</div>
					<div className="form-footer">
						<Button
							className="btn-cancel"
							onClick={() => history.push(fromPath)}
						>
							Cancel
						</Button>
						<Button
							className="btn-update"
							loading={submitting}
							onClick={() => handleTabUpdate(form1, stepRequiredFields[0])}
						>
							Update
						</Button>
					</div>
				</>
			),
		},
		{
			key: "2",
			label: "Financial & Resource Plan",
			children: (
				<>
					<div
						ref={tab2BodyRef}
						style={{
							minHeight: tab2BodyHeight ? `${tab2BodyHeight}px` : undefined,
						}}
					>
						<FinancialResourcePlanFieldsForMatter {...sharedStep2Props} />
					</div>
					<div className="form-footer">
						<Button
							className="btn-cancel"
							onClick={() => history.push(fromPath)}
						>
							Cancel
						</Button>
						<Button
							className="btn-update"
							loading={submitting}
							onClick={() => handleTabUpdate(form2, stepRequiredFields[1])}
						>
							Update
						</Button>
					</div>
				</>
			),
		},
		{
			key: "3",
			label: "Billing",
			children: (
				<>
					<div
						ref={tab3BodyRef}
						style={{
							minHeight: tab3BodyHeight ? `${tab3BodyHeight}px` : undefined,
						}}
					>
						<BillingForMatter {...sharedStep3Props} />
					</div>
					<div className="form-footer">
						<Button
							className="btn-cancel"
							onClick={() => history.push(fromPath)}
						>
							Cancel
						</Button>
						<Button
							className="btn-update"
							loading={submitting}
							onClick={() => handleTabUpdate(form3, stepRequiredFields[2])}
						>
							Update
						</Button>
					</div>
				</>
			),
		},
	];

	return (
		<PageWrap>
			<div className="breadcrumb-wrap">
				<Breadcrumb>
					<Breadcrumb.Item
						onClick={() => history.push(fromPath)}
						style={{ cursor: "pointer", color: "#8c98aa" }}
					>
						Matter
					</Breadcrumb.Item>
					<Breadcrumb.Item
						onClick={() => history.push(fromPath, { returnTab })}
						style={{ cursor: "pointer", color: "#8c98aa" }}
					>
						{location.state?.matterName
							? location.state.matterName
							: "Editing Matter"}
					</Breadcrumb.Item>
					{location?.state?.returnTab && (
						<Breadcrumb.Item>Editing Matter</Breadcrumb.Item>
					)
					}
				</Breadcrumb>
			</div>
			<Tabs
				activeKey={activeTab}
				onChange={handleTabChange}
				items={tabItems}
				style={{ paddingTop: 8 }}
			/>
			<Modal
				open={conflictModalVisible}
				onCancel={() => setConflictModalVisible(false)}
				centered
				width={480}
				footer={[
					<ButtonFilled
						key="ok"
						style={{
							background: "#00685F",
							borderColor: "#00685F",
							color: "#fff",
							borderRadius: 6,
							fontWeight: 500,
						}}
						onClick={() => setConflictModalVisible(false)}
					>
						OK
					</ButtonFilled>,
				]}
				title={
					<div style={{ display: "flex", alignItems: "center", gap: 10 }}>
						<span
							style={{
								display: "inline-flex",
								alignItems: "center",
								justifyContent: "center",
								width: 32,
								height: 32,
								borderRadius: "50%",
								background: "#fff3cd",
								flexShrink: 0,
							}}
						>
							<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
								<path
									d="M12 2L2 21h20L12 2z"
									fill="#faad14"
									stroke="#faad14"
									strokeWidth="1"
								/>
								<text
									x="12"
									y="17"
									textAnchor="middle"
									fontSize="12"
									fontWeight="bold"
									fill="#fff"
								>
									!
								</text>
							</svg>
						</span>
						<span style={{ fontSize: 16, fontWeight: 600, color: "#1a1a2e" }}>
							Timeline Conflict Detected
						</span>
					</div>
				}
			>
				<div style={{ padding: "8px 0 4px" }}>
					<p
						style={{
							margin: 0,
							color: "#444",
							lineHeight: 1.6,
							fontSize: 14,
						}}
					>
						The revised matter timeline conflicts with existing resource
						allocation dates. Please update the resource booking dates
						before saving.
					</p>
				</div>
			</Modal>
		</PageWrap>
	);
};

export default CreateMatter;